import { Deserializable } from "@app/interfaces/deserializable";

export class ArisJmsMessage {

    type: string;   
    messageType: number;
    arCode: string;
    account: string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }

}
